module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-kia.ea2c049e.jpg";